import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v16h7v2h8v-2h6.99L23 3zm-2 14H3V5h18v12z"
}), 'TvSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TvSharp.js
// module id = 6962
// module chunks = 2